import { GetterTree } from "vuex";
import {State} from '@/store/modules/synthetics/applications/applications.store';
const getters: GetterTree<State, State> = {
    getCurrentErrorName: state => {
        return state.currentEventItem.errorLog.message;
      },
      getCurrentEventID: state => {
        return state.currentEventID;
      },
      getEventCount: state => {
        return state.currentEventItem.events ? state.currentEventItem.events : 0;
      },
      getUptimeModalChart: state => {
        return state.chartTemplate;
      }
}

export default getters;